import "~/js/modules/fend";
import Cookie from "~/js/modules/Cookie";
// react form components
import CountryStateSelector from "~/js/components/form-controls/CountryStateSelector";
import CustomRecaptcha from "~/js/components/form-controls/CustomRecaptcha";

import { PhoneCodeToggler } from "~/js/modules/gcv/phone-code-toggler";
import countryPhoneCodes from "~/js/modules/country-phone-codes";

if (!Cookie.has("ALREADY_SUBSCRIBED")) {
  $("#footer-form-container").show();
}

const internals = {
  formSubmitted() {
    const $form = $(".subscribe-form");
    const $thankyouMessage = $(".thank-you-message-wrapper");

    $form.slideUp("fast");
    $thankyouMessage.slideDown("fast");
    document.cookie =
      "ALREADY_SUBSCRIBED=true; Path=/; expires=Fri, 31 Dec 9999 23:59:59 GMT;";
  },
};

if (window.beaches_app.extra.countries) {
  // create new array for countries and appending a new object that represents default value
  const countries = [
    {
      name: "Please Select A Country",
      id: "",
      regionCode: "",
      code: "",
    },
    ...window.beaches_app.extra.countries,
  ];

  // create new array for states and appending a new object that represents default value
  const states = [];

  ReactDOM.render(
    <CountryStateSelector
      countries={countries}
      states={states}
      countryName="country"
      stateName="state"
      stateLabelWrapper="lg-4 hide"
      stateInputWrapper="lg-8 hide"
      countryLabelWrapper="lg-4"
      countryLabel="Select Country"
      countryInputWrapper="lg-8"
      isStateRequired={false}
    />,
    document.getElementById("country-state-selector")
  );
}

ReactDOM.render(
  <CustomRecaptcha wrapperClassName="xs-12 lg-12" />,
  document.getElementById("google-recaptcha")
);

// Form Validation
$(".subscribe-form").fend({
  customBehaviorAfterSuccess: internals.formSubmitted,
  rules: {
    firstName: "lettersOnly",
  },
});

$(document).ready(() => {
  const phoneTogglerOpts = {
    countryInput: "[name=country]",
    countryCodeLabel: "span.countryCode",
    phoneCodes: countryPhoneCodes,
  };

  const countryCodeHandler = new PhoneCodeToggler(phoneTogglerOpts);

  countryCodeHandler.init();

  const smsProp = document.querySelector(".sms");
  const countryInput = document.querySelector("#gcvCountryFieldId");
  const smsCheckBox = document.querySelector("#subscribeSms");

  countryInput.addEventListener("change", function (event) {
    if (event.target.value === "US") {
      smsProp.classList.remove("hideSms");
      smsProp.classList.add("showSms");
    } else if (event.target.value !== "US") {
      smsProp.classList.add("hideSms");
      smsProp.classList.remove("showSms");

      if (smsCheckBox.checked === true) {
        smsCheckBox.checked = false;
      }
    }
  });
});

const $submitButton = $(".form-submit-button");
const $subscribeSms = $("#subscribeSms");
const $subscribeSmsHidden = $("#subscribeSmsHidden");

$submitButton.click(() => {
  if ($subscribeSms.is(":checked") === true) {
    $subscribeSmsHidden.prop("disabled", true);
  } else if ($subscribeSms.is(":checked") === true && !isUsa) {
    $subscribeSmsHidden.prop("disabled", false);
  } else {
    $subscribeSmsHidden.prop("disabled", false);
  }
});
